import { NgModule } from '@angular/core';
import { AccredibleUserApiService } from './user.service';

@NgModule({
  providers: [AccredibleUserApiService],
})
export class AccredibleUserServiceModule {}
